const UUID_PREFIX_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}-/i;

/**
 * Strips a UUID prefix from a string (e.g. a filename).
 *
 * Example: `"550e8400-e29b-41d4-a716-446655440000-logo.png"` → `"logo.png"`
 */
export function stripUuidPrefix(value: string): string {
  return value.replace(UUID_PREFIX_REGEX, "");
}
